// extracted by mini-css-extract-plugin
export var audioPlayer = "_p2-0";